export default "__VITE_ASSET__Cjw4hDnX__"